var $ = require('jquery');
/**
 * 合并行和列
 * @param opt
 */
function rowColSpan(opt) {

    opt = $.extend(true, {
        $table: null,
        rowspan: { //需要行合并的表格索引
            $dom: null, // 若有$dom，则对比$dom中的值，否则对比$td中的值
            row: null  // 0  第1列的行 如果值相同则合并
        },
        colspan: { //需要列合并的表格索引
            $dom: null,
            col: []  //[1,2] 第2列到第3列 如果值相同则合并
        }
    }, opt, {
        rowsData: opt.$table && opt.$table.dataTable() && opt.$table.dataTable().fnGetNodes() || opt.$table.find('tbody tr') || []
    });
    opt.rowspan.row!=null && rowSpan(opt);
    opt.colspan.col.length!=0 && colSpan(opt);

    function rowSpan(opt) {
        var $firstRowspan; //第一个td dom
        var $firstTr; //第一个tr dom
        var $rowspan ; //符合合并条件的td dom
        var rowspan = 1;
        var row ; // 配置信息里面的rowspan对象
        if(opt) {
            row = opt.rowspan;
            if(row.row instanceof Array) {
                if(row.$dom) {
                    opt.rowsData.forEach(function (item, index) {
                        var $tr = $(item);

                        if (!$firstTr) {
                            $firstTr = $tr;
                        } else if (
                            ($tr.find(row.$dom).html() == $firstTr.find(row.$dom).html())
                        ) {
                            ++rowspan;
                            row.row.forEach(function (value,index) {
                                $rowspan = $tr.find('td:eq(' + (+value-index) + ')');
                                $rowspan.remove();
                                $firstTr.find('td:eq(' + (+value) + ')').attr('rowspan', rowspan);
                            })
                        } else {
                            $firstTr = $tr;
                            rowspan = 1;
                        }
                    });
                }
                else{
                    alert('请指定对比内容的dom！');
                }
            }
            else {
                opt.rowsData.forEach(function (item, index) {
                    $rowspan = $(item).find('td:eq(' + parseInt(row.row) + ')');
                    if (!$firstRowspan) {
                        $firstRowspan = $rowspan;
                    } else if ( // 若有$dom，则对比$dom中的值，否则对比$td中的值
                        (row.$dom && $rowspan.find(row.$dom).html() == $firstRowspan.find(row.$dom).html()) ||
                        ($rowspan.html() == $firstRowspan.html())
                    ) {
                        $rowspan.remove();
                        ++rowspan;
                        $firstRowspan.attr('rowspan', rowspan);
                    } else {
                        $firstRowspan = $rowspan;
                        rowspan = 1;
                    }
                });
            }
        }
    }

    /**
     * 合并列
     * @param opt
     */
    function colSpan(opt) {
        var col; // 配置信息里面的colspan对象
        if(opt) {
            col = opt.colspan;
            opt.rowsData.forEach(function(item, index) {
                var $colspanArr = []; //td dom
                var colspanArr = [];  //td中指定$dom的值
                var len ; //td dom数组的长度
                var isCol; //td中指定$dom值是否一致，一致：true
                col.col.forEach(function(c) {
                    var $temp = $(item).find('td:eq('+parseInt(c)+')');
                    $colspanArr.push($temp);
                    colspanArr.push( (col.$dom && $temp.find(col.$dom).html()) || ($temp.html()) );// 若有$dom，则取$dom中的值，否则取$td中的值
                });
                len = colspanArr.length;
                isCol = colspanArr.every(function(element, index, array) {
                    var i = index;
                    i = ++i == len ? index : i;
                    return element == array[i] || element==undefined;
                });
                if(isCol) {
                    $colspanArr.forEach(function(item, index) {
                        if(index == 0) {
                            item.attr('colspan', len);
                        } else {
                            item.remove();
                        }
                    });
                }
            });
        }
    }
}

module.exports = rowColSpan;



//////////////////
// WEBPACK FOOTER
// ./src/components/row-col-span.js
// module id = 191
// module chunks = 0